module.exports = __webpack_public_path__ + "assets/bgOzon.a9278e522d5949ae1eb1c7ee0e786233.jpg";